import { POST, PUT } from "../../APiHelper/API";

export const updateCupAPI = (
    data,
    onSuccess,
    onError
) => {

    PUT("/api/v1/cups/update", data, onSuccess, onError)
}